var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "d-flex flex-column align-items-center font-size-125 gap-20",
      },
      [
        _c(
          "svg",
          {
            attrs: {
              width: "68",
              height: "78",
              viewBox: "0 0 68 78",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M65.9548 21.4933L45.7326 1.27111C45.3301 0.868177 44.8522 0.548517 44.3262 0.33041C43.8001 0.112303 43.2362 2.65509e-05 42.6667 0H8.00005C6.0846 0 4.2476 0.76091 2.89317 2.11534C1.53874 3.46977 0.777832 5.30677 0.777832 7.22222V70.7778C0.777832 72.6932 1.53874 74.5302 2.89317 75.8847C4.2476 77.2391 6.0846 78 8.00005 78H60.0001C61.9155 78 63.7525 77.2391 65.1069 75.8847C66.4614 74.5302 67.2223 72.6932 67.2223 70.7778V24.5556C67.2222 23.4072 66.7663 22.3058 65.9548 21.4933ZM53.8612 21.6667H45.5556V13.3611L53.8612 21.6667ZM9.4445 69.3333V8.66667H36.8889V26C36.8889 27.1493 37.3455 28.2515 38.1581 29.0641C38.9708 29.8768 40.073 30.3333 41.2223 30.3333H58.5556V69.3333H9.4445ZM45.7326 42.0658L40.1389 47.6667L45.7434 53.2675C46.5575 54.0816 47.0148 55.1857 47.0148 56.3369C47.0148 57.4882 46.5575 58.5923 45.7434 59.4064C44.9293 60.2205 43.8252 60.6778 42.6739 60.6778C41.5227 60.6778 40.4186 60.2205 39.6045 59.4064L34.0001 53.8056L28.3992 59.41C27.5852 60.2241 26.481 60.6814 25.3298 60.6814C24.1785 60.6814 23.0744 60.2241 22.2603 59.41C21.4463 58.5959 20.9889 57.4918 20.9889 56.3406C20.9889 55.1893 21.4463 54.0852 22.2603 53.2711L27.8612 47.6667L22.2676 42.0658C21.8645 41.6628 21.5447 41.1842 21.3266 40.6576C21.1084 40.1309 20.9961 39.5664 20.9961 38.9964C20.9961 38.4263 21.1084 37.8619 21.3266 37.3352C21.5447 36.8086 21.8645 36.33 22.2676 35.9269C22.6706 35.5239 23.1492 35.2041 23.6758 34.986C24.2025 34.7678 24.767 34.6555 25.337 34.6555C25.907 34.6555 26.4715 34.7678 26.9982 34.986C27.5248 35.2041 28.0034 35.5239 28.4064 35.9269L34.0001 41.5278L39.6009 35.9233C40.004 35.5202 40.4825 35.2005 41.0092 34.9824C41.5358 34.7642 42.1003 34.6519 42.6703 34.6519C43.2404 34.6519 43.8048 34.7642 44.3315 34.9824C44.8582 35.2005 45.3367 35.5202 45.7398 35.9233C46.1429 36.3264 46.4626 36.8049 46.6808 37.3316C46.8989 37.8583 47.0112 38.4227 47.0112 38.9928C47.0112 39.5628 46.8989 40.1273 46.6808 40.6539C46.4626 41.1806 46.1429 41.6591 45.7398 42.0622L45.7326 42.0658Z",
                fill: "#fff",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "text-center vue-uploadbox-drop-text",
            class: _vm.darkText,
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm._f("trans")("Add a file to continue")) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex gap-10 flex-wrap justify-content-center" },
          [
            _c("div", { staticClass: "btn-group" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-light font-size-125 font-weight-bold text-wrap vue-uploadbox-file-button position-static d-flex align-items-center justify-content-center gap-10",
                  class: { "rounded-bottom-0": _vm.showDropdown },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.openFileUploadDialog($event)
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "16",
                        height: "18",
                        viewBox: "0 0 16 18",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M14.4033 8.6V5L10.8033 1H2.40327C2.1911 1 1.98762 1.08429 1.83759 1.23431C1.68756 1.38434 1.60327 1.58783 1.60327 1.8V16.2C1.60327 16.4122 1.68756 16.6157 1.83759 16.7657C1.98762 16.9157 2.1911 17 2.40327 17H7.20327M11.6033 11V16.6M8.80327 13.8H14.4033",
                          stroke: "#2E2E2E",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M10.4033 1V5H14.4033",
                          stroke: "#2E2E2E",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  ),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm._f("trans")("Choose File")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-light dropdown-toggle dropdown-toggle-split border-left",
                  class: { "rounded-bottom-0": _vm.showDropdown },
                  attrs: {
                    type: "button",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.$emit("toggle-drop-down")
                    },
                  },
                },
                [_c("i", { staticClass: "fa fa-chevron-down" })]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "dropdown-menu m-0 w-100 br-4 rounded-top-0 user-select-none",
                  class: { show: _vm.showDropdown },
                  attrs: { id: "dropdownMenu" },
                },
                [
                  _c("div", { staticClass: "dropdown-item px-0" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                        attrs: {
                          id: "DeviceUploadButton",
                          title: _vm._f("trans")("Upload From Device"),
                          tag: "span",
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.openFileUploadDialog($event)
                          },
                        },
                      },
                      [
                        _vm._m(0),
                        _vm._v(
                          _vm._s(_vm._f("trans")("From Device")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-divider" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-item px-0" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                        attrs: {
                          id: "dropboxButton",
                          title: _vm._f("trans")(
                            "Choose one or more files from Dropbox"
                          ),
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.$emit("open-drop-box-dialog")
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "px-75" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 43 40",
                                version: "1.1",
                                width: "15px",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z",
                                  fill: "#007EE5",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(
                          _vm._s(_vm._f("trans")("From Dropbox")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-divider" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-item px-0",
                      class: { "opacity-65": _vm.disableGdriveButton },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.$emit("open-g-drive-dialog")
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                          attrs: {
                            id: "gdriveButton",
                            title: _vm._f("trans")(
                              "Choose one or more files from Google Drive"
                            ),
                          },
                        },
                        [
                          _c("span", { staticClass: "px-75" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "15px",
                                  viewBox: "0 0 87.3 78",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z",
                                    fill: "#0066da",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z",
                                    fill: "#00ac47",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.502l5.852 11.5z",
                                    fill: "#ea4335",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z",
                                    fill: "#00832d",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z",
                                    fill: "#2684fc",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z",
                                    fill: "#ffba00",
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(
                            _vm._s(_vm._f("trans")("From Google Drive")) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-divider" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "dropdown-item px-0" },
                    [
                      _c(
                        "RouterLink",
                        {
                          staticClass:
                            "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                          attrs: {
                            id: "externalUrlButton",
                            to: { name: "remote-url" },
                            title: _vm._f("trans")(
                              "Enter the link of a file you want to use"
                            ),
                            tag: "span",
                          },
                        },
                        [
                          _c("span", { staticClass: "px-75" }, [
                            _c("i", {
                              staticClass: "fa fa-link",
                              staticStyle: { width: "15px" },
                            }),
                          ]),
                          _vm._v(
                            _vm._s(_vm._f("trans")("From URL")) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-divider" }),
                  _vm._v(" "),
                  _vm.hasClientId
                    ? _c(
                        "div",
                        {
                          staticClass: "dropdown-item px-0",
                          class: { "opacity-65": _vm.disableOnedriveButton },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.openOnedriveDialog.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                              attrs: {
                                id: "onedriveButton",
                                title: _vm._f("trans")(
                                  "Choose one or more files from OneDrive"
                                ),
                              },
                            },
                            [
                              _c("span", { staticClass: "px-75" }, [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      "data-v-b2efc490": "",
                                      width: "15px",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      viewBox: "0 5.5 32 20.5",
                                    },
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          "data-v-b2efc490": "",
                                          id: "STYLE_COLOR",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            "data-v-b2efc490": "",
                                            d: "M12.20245,11.19292l.00031-.0011,6.71765,4.02379,4.00293-1.68451.00018.00068A6.4768,6.4768,0,0,1,25.5,13c.14764,0,.29358.0067.43878.01639a10.00075,10.00075,0,0,0-18.041-3.01381C7.932,10.00215,7.9657,10,8,10A7.96073,7.96073,0,0,1,12.20245,11.19292Z",
                                            fill: "#0364b8",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            "data-v-b2efc490": "",
                                            d: "M12.20276,11.19182l-.00031.0011A7.96073,7.96073,0,0,0,8,10c-.0343,0-.06805.00215-.10223.00258A7.99676,7.99676,0,0,0,1.43732,22.57277l5.924-2.49292,2.63342-1.10819,5.86353-2.46746,3.06213-1.28859Z",
                                            fill: "#0078d4",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            "data-v-b2efc490": "",
                                            d: "M25.93878,13.01639C25.79358,13.0067,25.64764,13,25.5,13a6.4768,6.4768,0,0,0-2.57648.53178l-.00018-.00068-4.00293,1.68451,1.16077.69528L23.88611,18.19l1.66009.99438,5.67633,3.40007a6.5002,6.5002,0,0,0-5.28375-9.56805Z",
                                            fill: "#1490df",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            "data-v-b2efc490": "",
                                            d: "M25.5462,19.18437,23.88611,18.19l-3.80493-2.2791-1.16077-.69528L15.85828,16.5042,9.99475,18.97166,7.36133,20.07985l-5.924,2.49292A7.98889,7.98889,0,0,0,8,26H25.5a6.49837,6.49837,0,0,0,5.72253-3.41556Z",
                                            fill: "#28a8ea",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(
                                _vm._s(_vm._f("trans")("From OneDrive")) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-divider" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-item px-0" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                        attrs: {
                          id: "copyFromClipboard",
                          title: _vm._f("trans")("Copy From Clipboard"),
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.$emit("copy-from-clipboard")
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "px-75" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "14",
                                height: "17",
                                viewBox: "0 0 14 17",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M4.8 13.3C4.36 13.3 3.98347 13.1435 3.6704 12.8304C3.35733 12.5173 3.20053 12.1405 3.2 11.7V2.1C3.2 1.66 3.3568 1.28347 3.6704 0.9704C3.984 0.657333 4.36053 0.500533 4.8 0.5H12C12.44 0.5 12.8168 0.6568 13.1304 0.9704C13.444 1.284 13.6005 1.66053 13.6 2.1V11.7C13.6 12.14 13.4435 12.5168 13.1304 12.8304C12.8173 13.144 12.4405 13.3005 12 13.3H4.8ZM4.8 11.7H12V2.1H4.8V11.7ZM1.6 16.5C1.16 16.5 0.783467 16.3435 0.4704 16.0304C0.157333 15.7173 0.000533333 15.3405 0 14.9V4.5C0 4.27333 0.0768001 4.08347 0.2304 3.9304C0.384 3.77733 0.573867 3.70053 0.8 3.7C1.02667 3.7 1.2168 3.7768 1.3704 3.9304C1.524 4.084 1.60053 4.27387 1.6 4.5V14.9H9.6C9.82666 14.9 10.0168 14.9768 10.1704 15.1304C10.324 15.284 10.4005 15.4739 10.4 15.7C10.4 15.9267 10.3232 16.1168 10.1696 16.2704C10.016 16.424 9.82613 16.5005 9.6 16.5H1.6Z",
                                  fill: "#2E2E2E",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(
                          _vm._s(_vm._f("trans")("From Clipboard")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.hasExampleFile
              ? _c("div", { staticClass: "btn-group add-example-file" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-lg add-example-file btn-default white-space-nowrap mb-0 d-flex align-items-center gap-10 w-100",
                      attrs: { type: "button" },
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus add-example-file" }),
                      _vm._v(" "),
                      _c("strong", { staticClass: "add-example-file" }, [
                        _vm._v(_vm._s(_vm._f("trans")("Add sample file"))),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _vm.hasExampleFile
          ? _c("div", { staticClass: "text-center" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm._f("trans")(
                      "Add a file or test us for free with our sample file"
                    )
                  ) +
                  "\n        "
              ),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "px-75" }, [
      _c("i", {
        staticClass: "fa fa-folder-open",
        staticStyle: { width: "15px" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }